import { useEffect, useState, useCallback } from 'preact/hooks';
import { ruleInstances } from '@/rules';
import Box from './Box';
import Chip from './Chip';
import Condition from './Condition';
import DivPlacement from './DivPlacement';
import ShowAnyway from './ShowAnyway';

export default function Rule({ rule = {}, survey = {}, surveyData = {}, toggleDrawer }) {
	const [open, setOpen] = useState(false);
	const [_, forceRender] = useState(0);

	const ruleInstance = ruleInstances[rule.id];

	const isValid = useCallback(
		() =>
			ruleInstance?.getValidConditions().length > 0 &&
			rule.if?.some((condition, index) => ruleInstance?.getConditionState(index, state => state.triggered)),
		[rule, ruleInstance]
	);

	useEffect(() => {
		let startValid = isValid();

		const interval = setInterval(() => {
			const currentValid = isValid();
			if (startValid !== currentValid) {
				startValid = currentValid;
				forceRender(prev => prev + 1);
			}
		}, 300);

		return () => clearInterval(interval);
	}, [isValid]);

	useEffect(() => {
		ruleInstance?.onRuleChange(({ conditionsChanged }) => {
			if (conditionsChanged) {
				forceRender(prev => prev + 1);
			}
		});
	}, [ruleInstance]);

	return (
		<Box
			name="rule"
			onClick={e => {
				if (
					!e.target.closest('.mop-debug-conditions-container') &&
					!e.target.closest('.mop-debug-div-placement-container') &&
					!e.target.closest('.mop-debug-platform') &&
					!e.target.closest('.mop-debug-link') &&
					!e.target.closest('.mop-debug-show-anyway')
				) {
					setOpen(prev => !prev);
				}
			}}
			classes={open ? ['open'] : []}
		>
			<Box name="rule-header">
				<Box name="form-name">
					<Box>{survey.name}</Box>
					<Box name="form-type">{survey.formType}</Box>
				</Box>
				<Box name="right-content">
					<Chip active={isValid()} />
					<Box name="triangle" classes={open ? ['rotate'] : []} />
				</Box>
			</Box>
			{open && (
				<>
					<Box name="conditions-container">
						{rule.if?.map((condition, index) => (
							<Condition
								rule={rule}
								ruleInstance={ruleInstance}
								condition={condition}
								index={index}
								surveyData={surveyData}
								valid={
									ruleInstance?.getValidConditions().filter(validCondition => validCondition.index === index).length > 0
								}
							/>
						))}
					</Box>
					<Box name="div-placement-container">
						<DivPlacement rule={rule} />
					</Box>

					<Box name="platform">
						<Box name="space-between" style={!isValid() ? { width: '100%' } : {}}>
							{!isValid() && <ShowAnyway toggleDrawer={toggleDrawer} rule={rule} survey={survey} />}
							<Box>
								<Box
									component="a"
									href={`https://${survey.domain}/r/reporting/inbox?project_id=${survey.projectId}&survey_id=${survey.id}`}
									classes={['btn-link', 'mr-1']}
									target="_blank"
								>
									View feedback
								</Box>
								<Box
									component="a"
									href={`https://${survey.domain}/r/data-collection/survey/edit/${survey.id}?project_id=${survey.projectId}`}
									classes={['btn-link']}
									target="_blank"
								>
									Edit form
								</Box>
							</Box>
						</Box>
					</Box>
				</>
			)}
		</Box>
	);
}
